import { getUkrainianPlural } from 'helpers/getUkrainianPlural';
import styles from 'components/SelectionInfo/SelectionInfo.scss';

export const SelectionInfo = ({
  selectedItems,
  wordForms,
  isSelectionMode,
  noSelectionText = 'Нічого не виділено',
}) => {
  if (!isSelectionMode) return null;

  const count = selectedItems.length;

  return (
    <p className={styles.selectedEntries}>
      {count > 0 ? `Виділено ${count} ${getUkrainianPlural(count, wordForms)}` : noSelectionText}
    </p>
  );
};
